import React from "react";
import cx from "classnames";
import type { AutomationAction } from "@/hooks/firestore/models/baseAutomation";
import { RakebackChips, ShieldTickIcon } from "@picklebet/ui";
import type { ReactElement } from "react";
import { ReactComponent as ReturnIcon } from "@/features/perks/assets/return.svg";
import { ReactComponent as WinningBoostIcon } from "@/features/perks/assets/winnings.svg";
import { Link } from "@/features/shell/components/shared/Link/Link";

import * as styles from "./PerkIcon.module.scss";

type PerkColor = "yellow" | "green" | "orange" | "blue" | "purple";

export const PERK_CONFIG = {
  WINNINGS_BOOST: {
    icon: <WinningBoostIcon />,
    color: "orange",
    link: "/perks/my-perks",
  },
  STAKE_REFUND: {
    icon: <ReturnIcon />,
    color: "green",
    link: "/perks/my-perks",
  },
  PAY_AS_WINNER: {
    icon: <ShieldTickIcon />,
    color: "purple",
    link: "/perks/my-perks",
  },
  RAKEBACK: {
    icon: <RakebackChips className={styles.neutral} />,
    color: "blue",
    link: "/perks/rakeback",
  },
} as const satisfies Record<
  string,
  { icon: ReactElement; color: PerkColor; link: string }
>;

export type PerkType = keyof typeof PERK_CONFIG | AutomationAction["type"];

export const getPerkConfig = (type: PerkType) =>
  PERK_CONFIG[type as keyof typeof PERK_CONFIG];

type PerkIconProps = {
  type: PerkType;
  className?: string;
  onClick?: () => void;
};

const PerkIcon = ({ type, className, onClick }: PerkIconProps) => {
  const perk = getPerkConfig(type);
  if (!perk) return null;

  const icon = (
    <span className={cx(styles.icon, styles[perk.color], className)}>
      {perk.icon}
    </span>
  );

  if (onClick && perk.link) {
    return (
      <Link noStyles to={perk.link} onClick={onClick}>
        {icon}
      </Link>
    );
  }

  return icon;
};

export { PerkIcon };
